<template>
  <div class="main-page page-foreign-legal">
    <Menu :title="title" :home="true" />
    <div class="container-flex foreign-container">
      <div class="search-row">
        <input v-model.trim="keyword" maxlength="255" :placeholder="searchPlaceholder" @keyup.enter="search">
        <button class="search-button" @click="search"><span class="search-icon"></span>搜索</button>
      </div>
      <div class="workspace">
        <aside class="sidebar">
          <div v-if="isOverseas || isCases || kind === 'hk-macao-law'" class="category-group">
            <button class="group-title all-categories" :class="{ active: allSelected }" @click="selectAllCategories">{{ isCases ? '全部案例' : '全部' }}</button>
          </div>
          <template>
            <div v-for="group in sidebarGroups" :key="group.id" class="category-group">
              <button class="group-title" :class="{ opened: expandedGroups.indexOf(group.id) !== -1, active: !group.children.length && selectedId === group.id }" @click="toggleGroup(group)">
                <span>{{ group.title }}</span><i v-if="group.children.length"></i>
              </button>
              <div v-show="group.children.length && expandedGroups.indexOf(group.id) !== -1" class="group-children">
                <button :class="{ active: isOverseas ? continentName === group.title && !countryName && !countryCode : selectedGroupAll === group.id }" @click="selectGroupAll(group)">全部</button>
                <button v-for="category in group.children" :key="category.id" :class="{ active: isOverseas ? continentName === group.title && countryName === (category.countryName || '') && countryCode === (category.countryCode || '') : selectedId === category.id && selectedGroupAll !== group.id }" @click="selectChild(group, category)">{{ category.title }}</button>
              </div>
            </div>
          </template>
        </aside>
        <section class="results">
          <div class="legal-breadcrumb">{{ breadcrumb }}</div>
          <div v-if="loading" class="state">正在加载…</div>
          <div v-else-if="error" class="state error">{{ error }} <button @click="loadList">重新加载</button></div>
          <div v-else-if="!rows.length" class="state">暂无数据</div>
          <div v-else class="result-list">
            <button v-for="(item,index) in rows" :key="item.id || index" class="result-item" @click="openFile(item)">
              <span class="number">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
              <span class="result-content">
                <span class="title-line"><strong>{{ item.lawName || item.title }}</strong><em v-if="!isCases">有效</em></span>
                <span v-if="!isCases" class="date-line">{{ item.issueDate || '—' }} 发布　|　{{ item.effectiveDate || '—' }} 施行</span>
                <span v-else class="case-tags">{{ (item.countryTags || []).concat(item.fieldTags || []).join('　') }}</span>
              </span>
            </button>
          </div>
          <el-pagination v-if="total > pageSize" background layout="prev, pager, next" :page-size="pageSize" :total="total" :current-page="pageNo" @current-change="changePage" />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/Menu'

const configs = {
  regulations: { title: '涉外法律法规', rootTitle: '涉外法律法规', fallback: 'c41c2543496b20df54f2406b97eea593' },
  'overseas-law': { title: '域外法律查询', rootTitle: '域外法律查询', fallback: 'e48660363e01088b0970108c310c9f57' },
  'hk-macao-law': { title: '港澳法律查询', rootTitle: '港澳法律', fallback: 'e0ca1b40e4020f8e33725e32dc355b4d' },
  cases: { title: '典型案例' }
}

export default {
  components: { Menu },
  props: { kind: { type: String, required: true } },
  data () {
    return {
      categories: [], regions: [], rootId: '', selectedId: '', keyword: '', lawName: '',
      continentName: '', countryName: '', countryCode: '', rows: [], total: 0,
      pageNo: 1, pageSize: 10, loading: false, error: '', requestId: 0, expandedGroups: [], selectedGroupAll: ''
    }
  },
  computed: {
    config () { return configs[this.kind] || configs.regulations },
    title () { return this.config.title },
    isCases () { return this.kind === 'cases' },
    isOverseas () { return this.kind === 'overseas-law' },
    allSelected () {
      if (this.isOverseas) return !this.continentName && !this.countryName && !this.countryCode
      return this.isCases ? !this.selectedId : this.selectedId === this.rootId
    },
    searchPlaceholder () { return `请输入您想要查找的关键词进行${this.isCases ? '案例库' : '法规库'}搜索` },
    sidebarGroups () {
      if (this.isOverseas) return this.regions.map(region => ({
        id: region.continentName,
        title: region.continentName,
        children: (region.countries || []).map((country, index) => ({ ...country, id: country.countryCode || country.countryName || index, title: country.countryName || country.countryCode }))
      }))
      if (this.isCases || this.kind === 'hk-macao-law') {
        return this.categories.map(item => ({ ...item, children: item.children || [] }))
      }
      const definitions = [
        ['涉外法律', ['专门涉外法律', '含有涉外规定的法律']],
        ['涉外行政法规', ['专门涉外行政法规', '含有涉外规定的行政法规']],
        ['涉外部门规章', ['专门涉外部门规章', '含有涉外规定的部门规章']]
      ]
      const groups = definitions.map(([title, names]) => {
        const children = names.map(name => this.categories.find(item => item.title === name)).filter(Boolean)
        return { id: children.length ? children[0].id : title, title, children }
      }).filter(group => group.children.length)
      const childIds = groups.reduce((ids, group) => ids.concat(group.children.map(item => item.id)), [])
      return groups.concat(this.categories.filter(item => childIds.indexOf(item.id) === -1).map(item => ({ ...item, children: item.children || [] })))
    },
    selectedCategory () { return this.categories.find(item => item.id === this.selectedId) },
    breadcrumb () {
      if (this.isOverseas) return [this.continentName, this.countryName].filter(Boolean).join('  >  ') || this.title
      return `${this.title}  >  ${this.selectedCategory ? this.selectedCategory.title : (this.isCases ? '全部案例' : '全部')}`
    }
  },
  watch: { kind: { immediate: true, handler () { this.initialize() } } },
  beforeDestroy () { this.requestId++ },
  methods: {
    async initialize () {
      const requestId = ++this.requestId
      this.categories = []
      this.regions = []
      this.rows = []
      this.total = 0
      this.error = ''
      this.expandedGroups = []
      this.selectedGroupAll = ''
      this.keyword = this.lawName = this.continentName = this.countryName = this.countryCode = ''
      try {
        if (this.isCases) {
          this.categories = await this.$api.getForeignLegalCaseCategories() || []
          this.selectedId = ''
        } else {
          const roots = await this.$api.getForeignLegalLawCategories()
          if (requestId !== this.requestId) return
          const root = (roots || []).find(item => item.title === this.config.rootTitle)
          this.rootId = root ? root.id : this.config.fallback
          this.selectedId = this.rootId
          if (this.isOverseas) {
            this.regions = await this.$api.getForeignLegalLawRegions() || []
            if (this.regions.length) this.expandedGroups = [this.regions[0].continentName]
          } else {
            this.categories = await this.$api.getForeignLegalLawCategories({ categoryId: this.rootId }) || []
            if (this.kind === 'regulations' && this.categories.length) this.selectedId = this.categories[0].id
          }
        }
        if (!this.isOverseas && this.sidebarGroups.length) {
          this.expandedGroups = [this.sidebarGroups[0].id]
          if (this.sidebarGroups[0].children.length) this.selectedGroupAll = this.sidebarGroups[0].id
        }
        if (requestId === this.requestId) this.loadList(1)
      } catch (error) {
        if (requestId === this.requestId) this.error = '分类加载失败，请稍后重试'
      }
    },
    async loadList (page = this.pageNo) {
      const requestId = ++this.requestId
      this.pageNo = page
      this.loading = true
      this.error = ''
      const params = { pageNo: page, pageSize: this.pageSize }
      if (this.selectedId) params.categoryId = this.selectedId
      if (!this.isCases) Object.assign(params, { lawName: this.lawName, sortField: 'issueDate', sortOrder: 'desc' })
      else if (this.lawName) params.title = this.lawName
      if (this.isOverseas) Object.assign(params, { continentName: this.continentName, countryName: this.countryName, countryCode: this.countryCode })
      try {
        const fetchList = this.isCases ? this.$api.getForeignLegalCaseList : this.isOverseas ? this.$api.searchForeignLegalLaw : this.$api.getForeignLegalLawList
        const data = await fetchList(params)
        if (requestId !== this.requestId) return
        this.rows = data.result || []
        this.total = Number(data.totalCount) || 0
      } catch (error) {
        if (requestId === this.requestId) this.error = '列表加载失败，请稍后重试'
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    },
    search () { this.lawName = this.keyword; this.loadList(1) },
    resetSearch () { this.keyword = this.lawName = ''; this.loadList(1) },
    changePage (page) { this.loadList(page) },
    selectAllCategories () {
      this.selectedGroupAll = ''
      this.selectedId = this.isCases ? '' : this.rootId
      this.continentName = this.countryName = this.countryCode = ''
      this.loadList(1)
    },
    selectCategory (id) { this.selectedGroupAll = ''; this.selectedId = id; this.loadList(1) },
    selectGroupAll (group) {
      if (this.isOverseas) { this.selectRegion({ continentName: group.title }); return }
      this.selectedGroupAll = group.id; this.selectedId = group.id; this.loadList(1)
    },
    selectChild (group, category) {
      if (this.isOverseas) this.selectCountry({ continentName: group.title }, category)
      else this.selectCategory(category.id)
    },
    selectRegion (region) {
      this.continentName = region.continentName
      this.countryName = this.countryCode = ''
      if (this.expandedGroups.indexOf(region.continentName) === -1) this.expandedGroups.push(region.continentName)
      this.loadList(1)
    },
    selectCountry (region, country) { this.continentName = region.continentName; this.countryName = country.countryName || ''; this.countryCode = country.countryCode || ''; this.loadList(1) },
    toggleRegion (name) { this.expandedGroups = this.expandedGroups.indexOf(name) === -1 ? this.expandedGroups.concat(name) : this.expandedGroups.filter(item => item !== name) },
    toggleGroup (group) {
      if (!group.children.length) {
        if (this.isOverseas) this.selectRegion({ continentName: group.title })
        else this.selectCategory(group.id)
        return
      }
      this.expandedGroups = this.expandedGroups.indexOf(group.id) === -1 ? [group.id] : []
    },
    openFile (item) {
      if (!item.fileId) { this.$message.warning('暂无可查看附件'); return }
      this.$router.push({ name: 'ForeignLegalPdf', params: { fileId: item.fileId }, query: { title: item.lawName || item.title || '' } })
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-foreign-legal
  --panel-line rgba(255, 255, 255, 0.12)
  button
    appearance none
    -webkit-appearance none
    background transparent
    border 0
    margin 0
    font-family inherit
    cursor pointer
  .foreign-container.container-flex
    padding 0.18rem 0.5rem 0.25rem
  .foreign-container
    padding 0.18rem 0.5rem 0.25rem
    display flex
    flex-direction column
    overflow hidden
  .search-row
    display flex
    flex-shrink 0
    height 0.62rem
    margin-bottom 0.16rem
    border 0.03rem solid rgba(255, 255, 255, 0.88)
    border-radius 0.1rem
    overflow hidden
    background #fff
    input
      flex 1
      min-width 0
      padding 0 0.3rem
      text-align center
      color #444
      border 0
      outline none
      font-size 0.21rem
      &::placeholder
        color #aaa
    .search-button
      width 20%
      border-radius 0.08rem
      color #fff
      background linear-gradient(135deg, #3377e9, #2160d4)
      font-size 0.23rem
      .search-icon
        display inline-block
        width 0.22rem
        height 0.22rem
        margin-right 0.08rem
        border 0.025rem solid #fff
        border-radius 50%
        vertical-align -0.04rem
        position relative
        &:after
          content ''
          position absolute
          width 0.09rem
          height 0.025rem
          right -0.065rem
          bottom -0.025rem
          transform rotate(45deg)
          background #fff
  .workspace
    display flex
    flex 1
    min-height 0
    overflow hidden
  .sidebar
    width 19%
    margin-right 0.18rem
    flex-shrink 0
    overflow-y auto
    padding-right 0.06rem
    color #fff
    &::-webkit-scrollbar
      width 0.06rem
    &::-webkit-scrollbar-thumb
      border-radius 0.06rem
      background rgba(255,255,255,.48)
    .category-group
      margin-bottom 0.06rem
      border 1px solid var(--panel-line)
      border-radius 0.07rem
      overflow hidden
      background rgba(255, 255, 255, 0.2)
    .group-title
      display flex
      align-items center
      justify-content space-between
      width 100%
      min-height 0.73rem
      padding 0.12rem 0.25rem
      text-align left
      color #fff
      font-size 0.23rem
      font-weight normal
      i
        width 0.12rem
        height 0.12rem
        border-right 0.025rem solid #fff
        border-bottom 0.025rem solid #fff
        transform rotate(45deg)
        transition transform .2s
      &.opened i
        transform rotate(225deg)
      &.active
        background #ff942d
    .group-children
      padding 0.06rem 0.22rem 0.24rem
      button
        display block
        width 100%
        min-height 0.52rem
        padding 0.1rem 0.16rem
        text-align left
        border-radius 0.07rem
        color rgba(255,255,255,.9)
        font-size 0.2rem
        &.active
          color #fff
          background #ff942d
    .region-heading
      display flex
      align-items stretch
      position relative
      .group-title
        flex 1
        min-width 0
        width auto
        &.active
          color #fff
          background #ff942d
      .region-toggle
        display flex
        align-items center
        justify-content center
        width 0.55rem
        flex-shrink 0
        color #fff
        background transparent
        i
          width 0.12rem
          height 0.12rem
          border-right 0.025rem solid currentColor
          border-bottom 0.025rem solid currentColor
          transform rotate(45deg)
        &.opened i
          transform rotate(225deg)
  .results
    flex 1
    display flex
    min-width 0
    flex-direction column
    padding 0 0.3rem 0.18rem
    color #333
    border-radius 0.1rem 0.1rem 0 0
    background #fff
    overflow hidden
    .legal-breadcrumb
      height 0.62rem
      margin 0
      background transparent
      border-radius 0
      display flex
      align-items center
      flex-shrink 0
      padding 0 0.05rem
      font-size 0.2rem
      color #333
      border-bottom 1px solid #e6e6e6
    .result-list
      flex 1
      overflow-y auto
      padding-right 0.12rem
      &::-webkit-scrollbar
        width 0.06rem
      &::-webkit-scrollbar-thumb
        border-radius 0.06rem
        background #cfd7e5
    .result-item
      display flex
      align-items center
      width 100%
      min-height 1.3rem
      padding 0.25rem 0
      background transparent
      border-bottom 1px solid #e5e5e5
      text-align left
      color #333
      .number
        display none
      .result-content
        display flex
        flex-direction column
        min-width 0
      .title-line
        display flex
        align-items center
        strong
          font-size 0.22rem
          line-height 1.5
        em
          flex-shrink 0
          margin-left 0.14rem
          padding 0.025rem 0.12rem
          border-radius 0.18rem
          color #fff
          background #25c21d
          font-size 0.15rem
          font-style normal
      .date-line
        margin-top 0.09rem
        color #808080
        font-size 0.16rem
      .case-tags
        margin-top 0.09rem
        color #8792a1
        font-size 0.16rem
    .state
      flex 1
      display flex
      align-items center
      justify-content center
      color #8792a1
      font-size 0.22rem
      &.error
        color #c35444
    .el-pagination
      flex-shrink 0
      padding-top 0.15rem
      text-align center
@media screen and (orientation: portrait)
  .page-foreign-legal
    .foreign-container
      padding-left 0.25rem
      padding-right 0.25rem
    .search-row .search-button
      width 2rem
    .sidebar
      width 2.5rem
</style>
